import { defineMessages } from 'react-intl';
import { object, ref, string } from 'yup';

const messages = defineMessages({
  emailRequired: {
    id: 'createAccount.emailRequired',
    defaultMessage: 'Please enter an email.',
  },
  emailInvalid: {
    id: 'createAccount.emailInvalid',
    defaultMessage: 'Email is invalid.',
  },
  passwordMismatch: {
    id: 'createAccount.passwordMismatch',
    defaultMessage: "Passwords don't match.",
  },
  passwordRequired: {
    id: 'createAccount.passwordRequired',
    defaultMessage: 'Please enter a password.',
  },
  passwordLength: {
    id: 'createAccount.passwordLength',
    defaultMessage: 'Passwords should be at least 8 characters long.',
  },
});

const createAccount = object({
  email: string()
    .email(messages.emailInvalid)
    .required(messages.emailRequired)
    .default(''),
  password: string()
    .required(messages.passwordRequired)
    .min(8, messages.passwordLength)
    .default(''),
  confirmPassword: string()
    .min(8, messages.passwordLength)
    .oneOf([ref('password')], messages.passwordMismatch),
});

export default createAccount;
